import '../../../styles/platform-management-menu.css';

const PLATFORM_MANAGEMENT_SECTIONS = [
  { id: 'union-review', label: '유니온 심사' },
  { id: 'union-management', label: '유니온 관리' },
  { id: 'account-moderation', label: '계정·밴 관리', fullAdminOnly: true },
  { id: 'stickers', label: '콘 관리', fullAdminOnly: true },
  { id: 'nikke-db', label: '니케 DB', fullAdminOnly: true },
  { id: 'boss-db', label: '보스 DB', fullAdminOnly: true },
  { id: 'broadcast', label: '중계방 관리', fullAdminOnly: true },
];

export function PlatformManagementMenu({
  activeSection,
  onSelect,
  pendingUnionCount = 0,
  mobile = false,
  fullAdmin = true,
}) {
  const sections = fullAdmin
    ? PLATFORM_MANAGEMENT_SECTIONS
    : PLATFORM_MANAGEMENT_SECTIONS.filter((section) => !section.fullAdminOnly);

  return (
    <section className={`platform-management-menu ${mobile ? 'mobile' : 'desktop'}`} aria-label="플랫폼 관리 기능 선택">
      <header>
        <div>
          <h1>플랫폼 관리</h1>

        </div>
      </header>

      <div className="platform-management-menu-buttons" role="tablist" aria-label="플랫폼 관리 기능">
        {sections.map((section) => {
          const active = section.id === activeSection;
          return (
            <button
              key={section.id}
              type="button"
              role="tab"
              id={`platform-management-tab-${section.id}`}
              aria-selected={active}
              aria-controls={`platform-management-panel-${section.id}`}
              className={active ? 'active' : ''}
              onClick={() => onSelect(section.id)}
            >
              <span>{section.label}</span>
              {section.id === 'union-review' && pendingUnionCount > 0 ? (
                <strong aria-label={`승인 대기 ${pendingUnionCount}건`}>{pendingUnionCount}</strong>
              ) : null}
            </button>
          );
        })}
      </div>
    </section>
  );
}
